<template>
	<div class="bg-bg_color mt-2 " :class="'w-full'">
	  <div style="height:100vh; width:100%">
	    <iframe
	    :src="iframeUrl"
	    ref="iframeRef"
	    width="100%"
	    height="100%">
	    </iframe>
	  </div>
	</div>
</template>

<script>
import { getToken, getSecret } from '@/utils/auth'
export default {
data() {
    return {
      iframeUrl:''
    }
  },
  mounted(){
	  this.createUrl();
  },
  methods:{
	createUrl(){
		const id = this.$route.params && this.$route.params.id
		const exhibition_id = this.$route.params && this.$route.params.exhibition_id
		const token = getToken();
		const secret_key = getSecret();
		const domain = process.env.NODE_ENV === 'development' ? 'http://10.145.10.140:3001/' : 'https://vr.51act.cn/vr';
		this.iframeUrl = domain + '?mode=userView&token='+token+'&secret_key='+secret_key+'&exhibition_id='+exhibition_id+'&exhibitionData_id='+id;
	}
  }
}
		
</script>

<style>

</style>